<template>
  <div class="productTableCom">
    <v-data-table
      :headers="headersTmp"
      :items="propsItems"
      :item-key="itemKey"
      :hide-default-header="false"
      :items-per-page="-1"
      hide-default-footer
      class="rounded-lg"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-if="!items.length">
            <td :colspan="headersTmp.length" class="text-center">
              {{ $t('sale.sale_not-product') }}
            </td>
          </tr>
          <tr
            v-for="(item, trIndex) in getFormatRow(items)"
            :key="`group-${trIndex}`"
            v-bind:class="{
              rowColor: item.productMoveIndex % 2 === 0
            }"
          >
            <template v-for="(header, parentIndex) in headersTmp">
              <td
                v-bind:class="{
                  tdStyleCenter: getAlign(header.value) === 'center',
                  tdStyleEnd: getAlign(header.value) === 'end',
                  DisplayNone: getAlign(header.value) === ' d-none',
                  firstTd: item.isLastRow && 0 === parentIndex,
                  lastTd:
                    item.isLastRow && headersTmp.length - 1 === parentIndex
                }"
                :key="parentIndex"
                v-if="
                  (item.isFirst && !('rowspan' in header)) || header.rowspan
                "
                :rowspan="item.recipientLength"
              >
                <slot :name="header.value" v-bind:item="item.productMoveList">
                  <span v-if="isName(header, 'productName')">
                    <div>
                      {{ item.productMoveList.product.nameJp }}
                    </div>
                    <div>
                      {{ item.productMoveList.product.nameCn }}
                    </div>
                  </span>
                  <span v-else-if="isName(header, 'notYet')" class="red--text">
                    {{ getNumberValue(item.productMoveList, header) }}
                  </span>
                  <span v-else-if="isNumberTd(header)">
                    {{ getNumberValue(item.productMoveList, header) }}
                  </span>
                  <span v-else>
                    {{ getDefaultValue(item.productMoveList, header) }}
                  </span>
                </slot>
              </td>
              <td
                v-if="'rowspan' in header && !header.rowspan"
                :key="parentIndex"
                class="tdStyleRight"
              >
                <span v-if="isName(header, 'quantityAndStorageNo')">
                  {{ getRackInfo(item) }}
                </span>
                <span v-else>
                  <div class="px-2">
                    <v-text-field
                      :value="
                        item.productMoveList.rackNumberList[item.recipientIndex]
                          .count
                      "
                      @input="
                        setInputChange(
                          $event,
                          item.productMoveList,
                          item.productMoveList.rackNumberList[
                            item.recipientIndex
                          ]
                        )
                      "
                      type="number"
                      dense
                      height="32px"
                      outlined
                      hide-details
                      min="0"
                    ></v-text-field>
                  </div>
                </span>
              </td>
            </template>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { commonUtil, currencyUtil } from '@/util'

import NormalNumberInput from '@/components/items/inputs/NormalNumberInput'

export default {
  name: 'ShipTable',

  components: {
    // NormalNumberInput
  },
  props: {
    headers: [],
    propsItems: {
      type: Array,
      require: true,
      default: () => []
    },
    itemKey: String,
    search: { default: '' }
  },
  data: () => ({
    itemsDetail: [],
    localdata: []
  }),
  created() {
    this.createHeaders()
  },
  computed: {
    headersTmp() {
      const headersTmp = this.headers.map((header) => {
        const tmp = { ...header }
        tmp.text = this.$t(tmp.text)
        delete tmp.inputType
        delete tmp.unit
        return tmp
      })
      return headersTmp
    },
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    isNumberTd(header) {
      const ret = [
        'product.productNumber',
        'productName',
        'product.capacity'
      ].find((ele) => ele === header.value)
      return !ret
    },

    setInputChange(event, productMoveList, rackNumberList) {
      // alert(event)
      // console.log(JSON.stringify(productMoveList))
      // console.log(JSON.stringify(rackNumberList))

      this.$emit(
        'change',
        event,
        productMoveList.productMoveId,
        productMoveList.productId,
        rackNumberList.rackNumber
      )
    },

    getInputData(item, propertyName) {
      const rackNumber = item.productMoveList.rackNumberList.length
        ? item.productMoveList.rackNumberList[item.recipientIndex]
        : {}
      const isPropertyName = propertyName in rackNumber
      return isPropertyName ? rackNumber[propertyName] : ''
    },
    getRackInfo(item) {
      const quantity = this.getInputData(item, 'quantity')
      const rackNumber = this.getInputData(item, 'rackNumber')
      const ret = rackNumber
        ? quantity + '（' + rackNumber + '）'
        : quantity + '（' + this.$t('common.common_no-rack-number') + '）'
      return ret
    },

    getFormatRow(productMoves) {
      return productMoves.reduce((result, current, currentIndex) => {
        let isMinRecipientId = true

        const isLastRow = productMoves.length - 1 === currentIndex

        if (!current.rackNumberList.length) {
          result.push({
            productMoveIndex: currentIndex,
            isLastRow: isLastRow,
            productMoveId: current.productMoveId,
            isFirst: isMinRecipientId,
            recipientIndex: -1,
            recipientLength: 1,
            recipientInfo: {},
            productMoveList: current
          })
        } else {
          current.rackNumberList.map((ele, index) => {
            result.push({
              productMoveIndex: currentIndex,
              isLastRow: isLastRow,
              productMoveId: current.productMoveId,
              isFirst: isMinRecipientId,
              recipientIndex: index,
              recipientLength: current.rackNumberList.length,
              recipientInfo: ele,
              productMoveList: current
            })
            isMinRecipientId = false
          })
        }

        return result
      }, [])
    },

    createHeaders() {
      this.itemsDetail = this.headers.map((header) => {
        return {
          value: header.value,
          inputType: 'inputType' in header ? header.inputType : '',
          unit: 'unit' in header ? header.unit : '',
          currencyIdName:
            'currencyIdName' in header ? header.currencyIdName : '',
          align: 'align' in header ? header.align : ''
        }
      })
    },
    isName(header, name) {
      return header.value === name
    },
    getRowValue(obj, path) {
      let tmp = this.getValue(obj, path)
      return typeof tmp === 'undefined' ? '' : tmp
    },
    getValue(obj, path) {
      if (!path) return obj
      const properties = path.split('.')
      return this.getValue(obj[properties.shift()], properties.join('.'))
    },
    getItemsDetailRecord(value) {
      return this.itemsDetail.find((header) => header.value === value)
    },
    getUnit(item, header) {
      const tmp = this.getItemsDetailRecord(header.value)
      if (!tmp.currencyIdName) return ''

      const currencyId = item[tmp.currencyIdName]
      return currencyUtil.findCurrencyNameById(currencyId).unitName
    },
    getAlign(value) {
      const tmp = this.getItemsDetailRecord(value)
      return tmp ? tmp.align : ''
    },

    formatHyphen(str) {
      return commonUtil.nullEmptyFormatHyphen(str)
    },
    getDefaultValue(item, header) {
      const val = this.getRowValue(item, header.value)
      return val ? val + this.getUnit(item, header) : '-'
    },
    getNumberValue(item, header) {
      const val = this.getRowValue(item, header.value)
      return val ? val + this.getUnit(item, header) : 0
    }
  }
}
</script>
<style lang="scss" scoped>
.productTableCom {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1);
    border-collapse: collapse;
    text-align: center !important;
    padding: 10px 0px !important;
    white-space: pre-wrap;

    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table td {
    // background-color: #f6f6f6;
    border-collapse: collapse;

    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td {
    // background-color: #fff;
    border-collapse: collapse;

    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table tr:hover td {
    background-color: #eee;
  }

  // ::v-deep .v-data-table thead th:first-child {
  //   border-radius: 10px 0 0 0;
  // }
  // ::v-deep .v-data-table thead th:last-child {
  //   border-radius: 0 10px 0 0;
  // }
  ::v-deep .v-data-table td:last-child {
    padding: 0 !important;
  }

  .tdStyleCenter {
    text-align: center !important;
  }

  .tdStyleRight {
    text-align: right !important;
  }

  .rowColor {
    // background-color: #f6f6f6;
  }
  // .firstTd {
  //   border-radius: 0 0 0 10px;
  // }
  // .lastTd {
  //   border-radius: 0 0 10px 0;
  // }
}
</style>
